import { render, staticRenderFns } from "./StudentLearningScreen.vue?vue&type=template&id=65434f6e&scoped=true"
import script from "./StudentLearningScreen.vue?vue&type=script&lang=js"
export * from "./StudentLearningScreen.vue?vue&type=script&lang=js"
import style0 from "./StudentLearningScreen.vue?vue&type=style&index=0&id=65434f6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65434f6e",
  null
  
)

export default component.exports